import {
  BookOpenCheck,
  CheckCircle2,
  ClipboardCheck,
  FileText,
  ShieldCheck,
  TrendingUp,
} from "lucide-react";

import jsPDF from "jspdf";
import "jspdf-autotable";

const handleDownloadPDF = (analysisResult) => {
  try {
    const data = analysisResult?.openAIResponse || analysisResult?.analysisData || {};
    const doc = new jsPDF("p", "pt", "a4");
    let yPos = 40;

    // Title
    doc.setFontSize(16);
    doc.text("Property Document Analysis Report", 40, yPos);
    yPos += 40;

    // Owner & Property Summary
    doc.setFontSize(14);
    doc.text("Owner & Property Summary", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Owner Name: ${data.ownerDetails?.name || data.propertyOwner?.name || data.ownerName || 'N/A'}`, 40, yPos);
    doc.text(`PAN: ${data.ownerDetails?.pan || data.propertyOwner?.pan || data.pan || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Aadhaar: ${data.ownerDetails?.aadhar || data.propertyOwner?.aadhar || data.aadhar || 'N/A'}`, 40, yPos);
    doc.text(`Ownership Type: ${data.ownerDetails?.ownershipType || data.propertyDetails?.ownershipType || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Borrower Same as Owner: ${data.ownerDetails?.borrowerSameAsOwner || data.propertyDetails?.borrowerSameAsOwner || 'N/A'}`, 40, yPos);
    doc.text(`Property Type: ${data.propertyDetails?.propertyType || data.property?.type || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Land Use: ${data.propertyDetails?.landUse || data.property?.usage || 'N/A'}`, 40, yPos);
    yPos += 15;
    doc.text(`Address: ${data.propertyDetails?.address || data.property?.address || data.address || 'N/A'}`, 40, yPos);
    yPos += 30;

    // Certified Copy Verification
    doc.setFontSize(14);
    doc.text("Certified Copy Verification", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Issued By: ${data.certifiedCopyVerification?.issuedBy || 'N/A'}`, 40, yPos);
    doc.text(`Date of Issue: ${data.certifiedCopyVerification?.dateOfIssue || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Matches Original: ${data.certifiedCopyVerification?.matchesOriginal || 'N/A'}`, 40, yPos);
    doc.text(`Stamp Duty/Page Numbers: ${data.certifiedCopyVerification?.stampDutyPageNumbers || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Digitally Certified: ${data.certifiedCopyVerification?.digitallyCertified || 'N/A'}`, 40, yPos);
    doc.text(`Updated Copy (6 months): ${data.certifiedCopyVerification?.updatedCopy || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Legal Compliance Checklist
    doc.setFontSize(14);
    doc.text("Legal Compliance Checklist", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Title Clear: ${data.legalCompliance?.titleClear || 'N/A'}`, 40, yPos);
    doc.text(`EC Clean: ${data.legalCompliance?.ecClean || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Legally Permitted: ${data.legalCompliance?.legallyPermitted || 'N/A'}`, 40, yPos);
    doc.text(`Matches Layout: ${data.legalCompliance?.matchesLayout || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Occupancy Certificate: ${data.legalCompliance?.occupancyCertificate || 'N/A'}`, 40, yPos);
    doc.text(`Litigation/Dispute: ${data.legalCompliance?.litigationDispute || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`GPA/POA: ${data.legalCompliance?.gpaPoa || 'N/A'}`, 40, yPos);
    yPos += 30;

    // Property & Construction Risk Snapshot
    doc.setFontSize(14);
    doc.text("Property & Construction Risk Snapshot", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Area: ${data.propertyRisk?.area || 'N/A'}`, 40, yPos);
    doc.text(`Deviations: ${data.propertyRisk?.deviations || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Developer Record: ${data.propertyRisk?.developerRecord || 'N/A'}`, 40, yPos);
    doc.text(`Built as per Plan: ${data.propertyRisk?.builtAsPerPlan || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`RERA Registered: ${data.propertyRisk?.reraRegistered || 'N/A'}`, 40, yPos);
    doc.text(`Completion: ${data.propertyRisk?.completion || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Fit for Loan: ${data.propertyRisk?.fitForLoan || 'N/A'}`, 40, yPos);
    yPos += 30;

    // Property Document Dashboard
    doc.setFontSize(14);
    doc.text("Property Document Dashboard", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Title Clarity: ${data.propertyDashboard?.titleClarity || 'N/A'}`, 40, yPos);
    doc.text(`Legal Construction: ${data.propertyDashboard?.legalConstruction || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Encumbrance: ${data.propertyDashboard?.encumbrance || 'N/A'}`, 40, yPos);
    doc.text(`Owner Authenticity: ${data.propertyDashboard?.ownerAuthenticity || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Verified by Lawyer: ${data.propertyDashboard?.verifiedByLawyer || 'N/A'}`, 40, yPos);
    doc.text(`Loan Eligibility: ${data.propertyDashboard?.loanEligibility || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Final Analyst Comments & Recommendation
    doc.setFontSize(14);
    doc.text("Final Analyst Comments & Recommendation", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Legal Opinion: ${data.finalAnalyst?.legalOpinion || 'N/A'}`, 40, yPos);
    doc.text(`Loan Eligibility: ${data.finalAnalyst?.loanEligibility || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Final Comments
    doc.setFontSize(14);
    doc.text("Final Comments", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    const comments = data.finalComments || [
      "Property document analysis completed based on available documentation."
    ];
    comments.forEach(comment => {
      doc.text(`• ${comment}`, 40, yPos);
      yPos += 15;
    });

    doc.save("property-document-analysis-report.pdf");
  } catch (error) {
    console.error('PDF generation error:', error);
    alert(`Error generating PDF: ${error.message}`);
  }
};

const PropertyDocumentAnalyser = ({ analysisResult }) => {
  const data =
    analysisResult?.openAIResponse || analysisResult?.analysisData || {};

  const getValue = (path, defaultValue = "N/A") => {
    return (
      path?.split(".").reduce((obj, key) => obj?.[key], data) || defaultValue
    );
  };
  return (
    <div className="bg-[#131313] text-white p-4 sm:p-6 text-sm space-y-6 min-h-screen max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">
        <div className="w-full sm:max-w-sm">
          <label className="block mb-1 text-sm">Select Analyzer Type</label>
          <select className="w-full bg-[#1f1f1f] border border-[#333] rounded-md px-4 py-2 text-white">
            <option>Universal Property Document Analyser</option>
          </select>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
         
          <button
            onClick={() => handleDownloadPDF(analysisResult)}
            className="bg-[#FFCA20] hover:bg-[#e6b91a] text-black px-4 py-2 rounded-md font-semibold text-sm"
          >
            Download Report
          </button>
        </div>
      </div>

      {/* Owner & Property Summary */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 space-y-2 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-lg font-semibold">
          🏠 Owner & Property Summary
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Owner Name</strong>
            <span className="text-white">
              {getValue("ownerDetails.name") ||
                getValue("propertyOwner.name") ||
                getValue("ownerName")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">PAN</strong>
            <span className="text-white">
              {getValue("ownerDetails.pan") ||
                getValue("propertyOwner.pan") ||
                getValue("pan")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Aadhaar</strong>
            <span className="text-white">
              {getValue("ownerDetails.aadhar") ||
                getValue("propertyOwner.aadhar") ||
                getValue("aadhar")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Ownership Type</strong>
            <span className="text-white">
              {getValue("ownerDetails.ownershipType") ||
                getValue("propertyDetails.ownershipType")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Borrower Same as Owner</strong>
            <span className="text-white">
              {getValue("ownerDetails.borrowerSameAsOwner") ||
                getValue("propertyDetails.borrowerSameAsOwner")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Property Type</strong>
            <span className="text-white">
              {getValue("propertyDetails.propertyType") ||
                getValue("property.type")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Land Use</strong>
            <span className="text-white">
              {getValue("propertyDetails.landUse") ||
                getValue("property.usage")}
            </span>
          </div>
          <div className="flex flex-col col-span-1 sm:col-span-2 lg:col-span-3">
            <strong className="text-[#AAAAAA]">Address</strong>
            <span className="text-white">
              {getValue("propertyDetails.address") ||
                getValue("property.address") ||
                getValue("address")}
            </span>
          </div>
        </div>
      </div>

      {/* Key Property Documents */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <FileText size={18} /> Key Property Documents – Availability & Status
        </div>
        <div className="grid grid-cols-3 gap-4 mt-2 mb-3">
          <h4 className="text-[#AAAAAA] font-semibold">Documents</h4>
          <h4 className="text-[#AAAAAA] font-semibold">Available</h4>
          <h4 className="text-[#AAAAAA] font-semibold">Status</h4>
        </div>
        <div className="space-y-3 mt-2">
          {(
            data.propertyDocuments || [
              {
                document: "Registered Sale Deed",
                available: "Available",
                status: "Verified",
              },
              {
                document: "Certified Copy of Sale Deed",
                available: "Available",
                status: "Not Verified",
              },
              {
                document: "Parent/Linked Deeds",
                available: "Available",
                status: "Verified",
              },
              {
                document: "Encumbrance Certificate (EC)",
                available: "Available",
                status: "Verified",
              },
              {
                document: "Approved Building Plan",
                available: "Not Available",
                status: "-",
              },
              {
                document: "Construction Permission",
                available: "Available",
                status: "Verified",
              },
              {
                document: "Commencement Certificate",
                available: "Available",
                status: "Not Verified",
              },
              {
                document: "Completion Certificate",
                available: "Not Available",
                status: "-",
              },
              {
                document: "Occupancy Certificate",
                available: "Available",
                status: "Verified",
              },
              {
                document: "Property Tax Receipts",
                available: "Not Available",
                status: "-",
              },
              {
                document: "Electricity/Water Bill",
                available: "Available",
                status: "Verified",
              },
              {
                document: "Khata/Patta Extract",
                available: "Available",
                status: "Verified",
              },
            ]
          ).map((doc, idx) => (
            <div key={idx} className="grid grid-cols-3 gap-4">
              <strong className="text-[#AAAAAA]">{doc.document}</strong>
              <span
                className={
                  doc.available === "Available"
                    ? "text-green-400"
                    : "text-red-500"
                }
              >
                {doc.available}
              </span>
              <span
                className={
                  doc.status === "Verified"
                    ? "text-green-400"
                    : doc.status === "Not Verified"
                    ? "text-red-500"
                    : "text-gray-400"
                }
              >
                {doc.status}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Certified Copy Verification */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <ClipboardCheck size={18} /> Certified Copy Verification
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Issued By</strong>
              <span className="text-white">
                {data.certifiedCopyVerification?.issuedBy || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Date of Issue</strong>
              <span className="text-white">
                {data.certifiedCopyVerification?.dateOfIssue || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Matches Original</strong>
              <span className="text-white">
                {data.certifiedCopyVerification?.matchesOriginal || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Stamp Duty/Page Numbers
              </strong>
              <span className="text-white">
                {data.certifiedCopyVerification?.stampDutyPageNumbers || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Digitally Certified</strong>
              <span className="text-white">
                {data.certifiedCopyVerification?.digitallyCertified || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Updated Copy (6 months)
              </strong>
              <span className="text-white">
                {data.certifiedCopyVerification?.updatedCopy || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Legal Compliance */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <BookOpenCheck size={18} /> Legal Compliance Checklist
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Title Clear</strong>
              <span className="text-white">
                {data.legalCompliance?.titleClear || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">EC Clean</strong>
              <span className="text-white">
                {data.legalCompliance?.ecClean || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Legally Permitted</strong>
              <span className="text-white">
                {data.legalCompliance?.legallyPermitted || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Matches Layout</strong>
              <span className="text-white">
                {data.legalCompliance?.matchesLayout || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Occupancy Certificate</strong>
              <span className="text-white">
                {data.legalCompliance?.occupancyCertificate || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Litigation/Dispute</strong>
              <span className="text-white">
                {data.legalCompliance?.litigationDispute || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">GPA/POA</strong>
              <span className="text-white">
                {data.legalCompliance?.gpaPoa || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Property Risk */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <TrendingUp size={18} /> Property & Construction Risk Snapshot
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Area</strong>
              <span className="text-white">
                {data.propertyRisk?.area || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Deviations</strong>
              <span className="text-white">
                {data.propertyRisk?.deviations || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Developer Record</strong>
              <span className="text-white">
                {data.propertyRisk?.developerRecord || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Built as per Plan</strong>
              <span className="text-white">
                {data.propertyRisk?.builtAsPerPlan || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">RERA Registered</strong>
              <span className="text-white">
                {data.propertyRisk?.reraRegistered || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Completion</strong>
              <span className="text-white">
                {data.propertyRisk?.completion || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Fit for Loan</strong>
              <span className="text-white">
                {data.propertyRisk?.fitForLoan || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Property Document Dashboard */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a] text-center">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <ShieldCheck size={18} /> Property Document Dashboard
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
          <div>
            <strong className="text-[#AAAAAA]">Title Clarity</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.propertyDashboard?.titleClarity || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Legal Construction</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.propertyDashboard?.legalConstruction || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Encumbrance</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.propertyDashboard?.encumbrance || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Owner Authenticity</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.propertyDashboard?.ownerAuthenticity || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Verified by Lawyer</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.propertyDashboard?.verifiedByLawyer || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Loan Eligibility</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.propertyDashboard?.loanEligibility || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Final Analyst Comments */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a] text-center">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <CheckCircle2 size={18} /> Final Analyst Comments & Recommendation
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <div>
            <strong className="text-[#AAAAAA]">Legal Opinion</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.finalAnalyst?.legalOpinion || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Loan Eligibility</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.finalAnalyst?.loanEligibility || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Final Comments */}
      <div className="bg-green-950 border border-green-600 rounded-lg p-4 text-green-400">
        <h3 className="font-semibold text-green-500 mb-2">📝 Final Comments</h3>
        <ul className="list-disc pl-5">
          {data.finalComments?.map((comment, index) => (
            <li key={index}>{comment}</li>
          )) || [
            <li key="default1">
              Property document analysis completed based on available
              documentation.
            </li>,
          ]}
        </ul>
      </div>
    </div>
  );
};

export default PropertyDocumentAnalyser;
